const featuresPay = {
    featureTitle: 'ធ្វើសេចក្តីសម្រេចអាជីវកម្មផ្អែកលើទិន្នន័យ',
    featureDescription:
        'ដឹងថាផលិតផលណាដែលលក់បានល្អ និងផ្តល់ប្រាក់ចំណេញច្រើនបំផុត ហើយអាចចូលមើលរបាយការណ៍ហិរញ្ញវត្ថុគ្រប់ពេលគ្រប់ទីកន្លែង។ អាជីវកម្មរបស់អ្នកនៅក្នុងដៃអ្នក!',
    featureButton: 'ការជាវប្រចាំខែពិសេសពីកម្មវិធី',
    featureStartingPrice: '៨០',
    featureEndingPart: '៣០',
    featureStaringText: 'ចាប់ពី',
    featureEndingText: 'ពាន់',

    features: [
        {
            title: 'ផលិតផលគ្មានដែនកំណត់',
            description: 'បន្ថែមផលិតផលទាំងអស់ដែលអ្នកកាន់កាប់ដោយគ្មានដែនកំណត់។'
        },
        {
            title: 'បុគ្គលិកគ្មានដែនកំណត់',
            description: 'បន្ថែមបុគ្គលិក/អ្នកគ្រប់គ្រងក្នុងអាជីវកម្មដោយគ្មានដែនកំណត់។'
        },
        {
            title: 'ប្រវត្តិគ្មានដែនកំណត់',
            description: 'មើលការផ្លាស់ប្តូរនៅក្នុងកំណត់ត្រាស្តុកចាស់ៗដោយគ្មានដែនកំណត់។'
        },
        {
            title: 'តម្រងប្រវត្តិ',
            description: 'ងាយស្រួលមើលប្រវត្តិដោយផ្អែកលើប្រភេទ ប្រភេទផលិតផល បុគ្គលិក និងកាលបរិច្ឆេទ។'
        },
        {
            title: 'ទាញយកទៅ Excel',
            description: 'ទាញយកប្រវត្តិកំណត់ត្រាស្តុកទៅ Microsoft Excel ដោយចុចតែម្ដង។'
        },
        {
            title: 'ទាញយកទៅ PDF',
            description: 'ទាញយកបញ្ជីផលិតផល និងស្តុកចុងក្រោយទៅ PDF ដោយចុចតែម្ដង។'
        }
    ],
    warehousesGuide: [
        {
            desc: 'បង្កើតឃ្លាំងច្រើនសម្រាប់ការគ្រប់គ្រងស្តុកបានប្រសើរជាងមុន។'
        },
        {
            desc: 'ចាត់ចែងផលិតផលទៅទីតាំងជាក់លាក់។'
        },
        {
            desc: 'តាមដានកម្រិតស្តុកនៅទូទាំងឃ្លាំង។'
        }
    ],
    addVariantsGuide: [
        { desc: 'បន្ថែមទំហំ ពណ៌ ឬវត្ថុធាតុផ្សេងៗ។' },
        { desc: 'កំណត់កម្រិតស្តុកសម្រាប់មួយៗ។' },
        { desc: 'តាមដានទូទាំងឃ្លាំង។' }
    ]
}

export default featuresPay
